const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
const { requestSettlements } = require('actions/accountSettlements');

const requestAccountSettlementsDetails = (accountId, settlementId) => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_DETAILS_REQUEST,
    payload: {
        accountId,
        settlementId
    }
});

const requestAccountSettlementsDetailsSuccess = (accountId, settlementId, data) => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_DETAILS_SUCCESS,
    payload: {
        accountId,
        settlementId,
        settlementsDetails: get(data, 'datoLiquidacion', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestAccountSettlementsDetailsFailure = (accountId, settlementId, error) => ({
    type: actionTypes.FETCH_ACCOUNT_SETTLEMENTS_DETAILS_FAILURE,
    payload: {
        accountId,
        settlementId,
        error
    }
});


const requestSettlementsDetailsFetch = (accountId, settlementId) => (dispatch, getState) => {
    const immAccountSettlements = getState().accountsSettlements.get(accountId);
    const immSettlement = immAccountSettlements.getIn(['byId', settlementId]);
    const immAccount = getState().accounts.getIn(['byId', accountId]);

    const detailsRequestData = {
        query: {
            idProducto: immAccount.get('newProduct'),
            idContrato: immAccount.get('newContractNumber'),
            digitoDeControl: immAccount.getIn(['ibanComplex', 'digitodecontrol']),
            numeroCuenta: immAccount.get('product') + immAccount.get('contractNumber'),
            indicador: immAccountSettlements.get('contractsTable'),
            codigoDeAplicacion: immSettlement.getIn(['extra', 'applicationTypeCode']),
            fechaHasta: immSettlement.get('dateTo'),
            importe: immSettlement.getIn(['creditAmount', 'amount']),
            divisa: immSettlement.getIn(['creditAmount', 'currency'])
        }
    };

    dispatch(requestAccountSettlementsDetails(accountId, settlementId));
    return APIGet(dispatch, apiURLBuilder.getURL('accountSettlementsDetails'), detailsRequestData)
        .then(response => dispatch(requestAccountSettlementsDetailsSuccess(accountId, settlementId, response)))
        .catch(response => dispatch(requestAccountSettlementsDetailsFailure(accountId, settlementId, response.error)))
}

const requestSettlementsDetails = (accountId, settlementId) => (dispatch) => {
    dispatch(requestSettlements(accountId))  // This method always checks if it's need to call API
        .then(() => dispatch(requestSettlementsDetailsFetch(accountId, settlementId)))
}

module.exports = {
    requestSettlementsDetails
}
